import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useContext, useEffect, useState } from "react";
import {
  genElDate,
  genElObject,
  genElText,
} from "../../../../components/utils/EditorDialogElementGenerator";
import EmployeeSelectorDialog from "../../../../dialogs/selectors/EmployeeSelectorDialog";
import { useSelector } from "react-redux";
import { isFinance, isSuperAdmin } from "../../../../utils/jelim/CheckUserType";

const isSmallScreen = window.innerWidth < 768;

const EmployeeVacationEditor = (props) => {
  const {
    visible,
    onHide,
    onConfirm,
    onDelete,
    loading,
    title,
    data,
    setData,
    addNewMode,
    error,
    setError,
    user,
  } = props;

  // dialog state
  const [showEmployeeSelector, setShowEmployeeSelector] = useState(false);

  useEffect(() => {
    if (props.visible) {
      if (data.date) {
        setData({
          ...data,
          date_jam: new Date(
            data.date
          ),
        });
      }
    }
  }, [props.visible]);

  /**
   * VALIDATE THE FORM DATA.
   *
   * @returns {boolean} - Returns true if the data is valid, otherwise false.
   * @returns {object} - Returns an object containing the error messages, format { field: message}.
   */
  const validate = () => {
    let valid = true;

    // console.log("Data", data);
    let newError = {};

    const date = data.date;
    if (!date) {
      newError = {
        ...newError,
        date: "Date can't be empty",
      };
      valid = false;
    }

    if (!data.data_employee || data.employee_id <= 0) {
      newError["data_employee"] = "Employee harus diisi";
      valid = false;
    }

    // if (!valid)
    setError(newError);

    return valid;
  };

  const refineData = (data) => {
    const _data = data;

    if (_data.id !== undefined && _data.id <= 0) {
      delete _data.id;
    }

    return _data;
  };

  // UI Event Handler

  const handleOnClickEmployee = () => {
    setShowEmployeeSelector(true);
  };

  const handleOnConfirmEmployee = (event, datas) => {
    let selected;
    event.preventDefault();
    if (datas && datas.length > 0) {
      selected = datas[0];
      setData({
        ...data,
        data_employee: selected,
        employee_id: selected.id,
      });
      setShowEmployeeSelector(false);
    }
    return selected;
  };


  // Only SuperAdmin/Finance can (re)assign which employee a vacation belongs to.
  const isPrivileged = !!(user && (isFinance(user.user_type) || isSuperAdmin(user.user_type)));

  // Everyone can view every vacation, but only the owner (or a privileged user)
  // may edit/delete an existing entry. New entries are always editable by their creator.
  const isOwner = !!(user && data.employee_id && user.employee_id && data.employee_id === user.employee_id);
  const canEdit = addNewMode || isPrivileged || isOwner;

  const elEmployee = genElObject({
    field: "data_employee",
    name: "Employee",
    value: data.data_employee ? data.data_employee.name : "",
    onClick: isPrivileged ? handleOnClickEmployee : null,
    disabled: !isPrivileged,
    error,
  });

  const elDate = genElDate({
    field: "date",
    name: "Date",
    primeFormat: "dd MM yy ",
    data,
    setData,
    disabled: !canEdit,
    error,
  });

  const elDescription = genElText({
    field: "description",
    name: "Description",
    data,
    setData,
    disabled: !canEdit,
    error,
  });

  const dialogFooter = (
    <div className="row-between-center w-100 pt-2">
      {canEdit && !addNewMode ? (
        <Button
          className="w-[8rem] md:w-[12rem]"
          label={isSmallScreen ? "Delete" : "Delete"}
          loading={loading}
          severity="danger"
          icon="pi pi-exclamation-triangle"
          onClick={(e) => onDelete(data)}
        />
      ) : (
        <div />
      )}
      <div className="row-end-center w-100">
        <Button
          // className="w-full"
          label="Close"
          loading={loading}
          icon="pi pi-arrow-left"
          onClick={(e) => {
            e.preventDefault();
            props.onHide();
          }}
        />
        {canEdit && (
          <Button
            // className="w-full"
            severity="success"
            loading={loading}
            label="Save"
            icon="pi pi-save"
            onClick={(e) => {
              const valid = validate();
              if (valid) {
                const _data = refineData(data);
                onConfirm(_data);
              }
            }}
          />
        )}
      </div>
    </div>
  );

  return (
    <Dialog
      visible={props.visible}
      header={title}
      modal
      className={`p-fluid w-[24rem] md:w-[47rem] min-h-[31rem]`}
      footer={dialogFooter}
      onHide={props.onHide}
      contentStyle={{ paddingBottom: "0px" }}
    >
      <EmployeeSelectorDialog
        title="Select Employee"
        visible={showEmployeeSelector}
        onHide={() => setShowEmployeeSelector(false)}
        onConfirm={handleOnConfirmEmployee}
      />

      <div className="col-start-start justify-start items-start w-full gap-4 pb-4 bg-white ">
        <div className="flex flex-col md:flex-row justify-start items-start gap-2 w-full">
          {elEmployee}
          {elDate}
        </div>
        {elDescription}
      </div>
    </Dialog>
  );
};
export default EmployeeVacationEditor;
